import {
  AccredibleObjectWithId,
  CustomAttribute,
  CustomAttributeOption,
  CustomAttributeValue,
} from '@accredible-frontend-v2/models';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sl-searchable-select-any-input',
  templateUrl: './searchable-select-any-input.component.html',
  styleUrls: ['./searchable-select-any-input.component.scss'],
})
export class SearchableSelectAnyInputComponent implements OnInit {
  @Input()
  customAttribute: CustomAttribute;

  @Output()
  optionsChanged = new EventEmitter<CustomAttributeValue>();

  selectedOptions: AccredibleObjectWithId[];

  ngOnInit(): void {
    const selectedOptions: AccredibleObjectWithId[] = [];
    if (this.customAttribute?.value) {
      this.customAttribute.options.forEach((option: CustomAttributeOption) => {
        if ((this.customAttribute.value as number[]).includes(option.id)) {
          selectedOptions.push({ label: option.label, id: option.id });
        }
      });
    }

    this.selectedOptions = selectedOptions;
  }

  handleSelectAnyInputSubmit(value: AccredibleObjectWithId[]): void {
    const customAttributeValue: CustomAttributeValue = value.map((o) => o.id) as number[];
    this.optionsChanged.emit(customAttributeValue);
  }
}
